module.exports = __webpack_public_path__ + "img/js_img.6db4cf59.png";